module.exports = __webpack_public_path__ + "static/media/cover_page_ma_ko_hun.b8a5ffc4.png";